// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__29AgZ","messages":"Chat_messages__2xzmL","dateDivider":"Chat_dateDivider__1wqls"};